<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员套餐</el-breadcrumb-item>
    </el-breadcrumb>
    <ex-table
      ref="table"
      :new-btn="handleAdd"
      :load-and-request="false"
      :request="fetchData"
    >
      <ex-table-column
        prop="id"
        label="ID"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="orderNo"
        label="套餐排序"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="price"
        label="价格"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="duration"
        label="时长"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="title"
        label="标题"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="durationRemark"
        label="时长文案"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="remark"
        label="描述文案"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="status"
        label="状态"
        align="center"
        data-type="select"
        :options="statusOptions"
      ></ex-table-column>
      <ex-table-column
        prop="createTime"
        label="创建时间"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="createTime"
        label="操作"
        align="center"
      >
        <template #default="{row}">
          <el-button type="text" size="small" @click="handleEdit(row)">编辑</el-button>
          <el-button type="text" size="small" @click="handleDelete(row)">删除</el-button>
        </template>
      </ex-table-column>
    </ex-table>

    <el-dialog
      title="套餐配置"
      :visible.sync="show"
      width="50%"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      @close="close"
    >
      <el-form :model="form" ref="form" label-width="80px" :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="标题" prop="title">
              <el-input v-model="form.title" placeholder="请输入标题"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-switch
                v-model="form.status"
                size="large"
                active-text="开启"
                inactive-text="禁用"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="排序" prop="orderNo">
              <el-input-number v-model="form.orderNo" placeholder="请输入排序"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="价格/分" prop="price">
              <el-input-number v-model="form.price" placeholder="请输入价格/分"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="时长" prop="duration">
              <el-input v-model="form.duration" placeholder="请输入时长"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="时长文案" prop="durationRemark">
              <el-input v-model="form.durationRemark" placeholder="请输入时长文案"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="描述文案" prop="remark">
            <el-input v-model="form.remark" placeholder="请输入描述文案"></el-input>
          </el-form-item>
        </el-row>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit">提交</el-button>
          <el-button @click="close">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  addMemberCombo,
  deleteMemberCombo,
  memberComboList,
  updateMemberCombo,
} from "../../api/configMG";

export default {
  data() {
    return {
      show: false,
      form: {
        title: '',
        orderNo: undefined,
        price: undefined,
        duration: undefined,
        durationRemark: '',
        remark: '',
        status: 0
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        orderNo: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入价格/分', trigger: 'blur' }
        ],
        duration: [
          { required: true, message: '请输入时长', trigger: 'blur' }
        ],
        durationRemark: [
          { required: true, message: '请输入时长文案', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入描述文案', trigger: 'blur' }
        ],
      },
      statusOptions: [
        { value: 0, label: '禁用' },
        { value: 1, label: '开启' }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.table.search();
    })
  },
  methods: {
    async fetchData(params) {
      let res = await memberComboList(params)
      return new Promise((c) => {
        c({
          records: res.data.list,
          total: res.data.total
        })
      })
    },
    close() {
      this.show = false
      this.$refs.form.resetFields();
      this.form = {
        title: '',
        orderNo: undefined,
        price: undefined,
        duration: undefined,
        durationRemark: '',
        remark: '',
        status: 0
      }
    },
    handleAdd() {
      this.show = true
    },
    handleEdit(row) {
      this.form = {...row, status: !!row.status}
      this.show = true
    },
    handleDelete(row) {
      this.$confirm('是否删除该套餐?', '提示', {
        type: 'warning'
      }).then(() => {
        deleteMemberCombo({ids: row.id}).then(res => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.$refs.table.search();
          } else {
            this.$message.error(res.message);
          }
        })
      }).catch(() => {});
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.status = this.form.status ? 1 : 0;
          if (this.form.id) {
            updateMemberCombo(this.form).then(res => {
              if (res.code === 0) {
                this.$message({
                  type: 'success',
                  message: '修改成功!'
                });
                this.close();
                this.$refs.table.search();
              } else {
                this.$message.error(res.message);
              }
            })
          } else {
            addMemberCombo(this.form).then(res => {
              if (res.code === 0) {
                this.$message({
                  type: 'success',
                  message: '添加成功!'
                });
                this.close();
                this.$refs.table.search();
              } else {
                this.$message.error(res.message);
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/machine/MemberCombo.vue